export function getKWsRegex(kw: string) {
  const parsedKW = kw.replace(/[^\w\s]/gi, '');
  const delimiters = '[\\s.,!?;:()\\[\\]{}"\'`-]';
  const regex = new RegExp(`(?<=${delimiters}|^)(${parsedKW})(?=${delimiters}|$)`, 'gi');
  return regex;
}
